import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { faqs } from '../data/faqs';
const facts = ['Digital product', 'Instant access', 'One-time purchase', 'No subscription'];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream py-10 sm:py-14 lg:py-20" aria-labelledby="faq-heading" data-id="element-21" data-mp="1glpvhxaattaa">
      <div className="mx-auto w-full max-w-2xl px-5 sm:px-8" data-id="element-22" data-mp="24baoza42w8xt">
        <h2 id="faq-heading" className="text-center font-serif text-[1.4rem] font-semibold uppercase leading-tight text-ink sm:text-3xl" data-id="element-23" data-mp="289qb7bsc5da6">
          Common questions
        </h2>

        <ul className="mt-5 space-y-2" data-id="element-24" data-mp="1zh6ewhzinksi">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className="overflow-hidden rounded-2xl border border-sandDark bg-ivory" data-id="element-25" data-mp="2ryiikus59tk0" data-mpi={index}>
                <h3 data-id="element-26" data-mp="14vtvbixxztii">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-4 py-3.5 text-left transition-colors duration-150 ease-out hover:bg-white focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-gold sm:px-5" data-id="element-27" data-mp="14sxthjiz4kos">
                    <span className="text-[0.9rem] font-semibold leading-snug text-ink sm:text-base" data-id="element-28" data-mp="1xjple4t0an6b">
                      {faq.question}
                    </span>
                    {isOpen ? <MinusIcon className="h-4 w-4 shrink-0 text-forest" aria-hidden="true" data-id="element-29" data-mp="35omjjxgi068" /> : <PlusIcon className="h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-30" data-mp="3ud14i165yhn7" />}
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-31" data-mp="1ybfvaho9smhl">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-32" data-mp="23aafno1vyj3t">
                      <p className="px-4 pb-4 text-[0.86rem] leading-relaxed text-muted sm:px-5" data-id="element-33" data-mp="2m4pe9ckac9r4">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <ul className="mt-5 flex flex-wrap justify-center gap-1.5" data-id="element-34" data-mp="34xjk9gzxkrj7">
          {facts.map(fact => <li key={fact} className="rounded-full border border-forest/20 bg-ivory px-3 py-1.5 text-[0.55rem] font-semibold uppercase tracking-label text-forest" data-id="element-35" data-mp="ta6npfzp7g22">
              {fact}
            </li>)}
        </ul>
      </div>
    </section>;
}